import { useEffect } from "react";

import { updateBeamer } from "#structure/providers/beamer";

interface BeamerRouteSyncProps {
	pathname: string;
}

export function BeamerRouteSync({ pathname }: BeamerRouteSyncProps) {
	useEffect(() => {
		updateBeamer();
	}, [pathname]);

	return null;
}
